import React, { Component } from 'react';
import css from './filter.scss';
import FilterEvent from './filter.event';

class Filter extends Component {
	state = {
		name: 'Trier par',
		visible: false,
	};
	filters = [
		{
			name: 'Nom du Client',
			prop: 'client_name',
		},
		{
			name: 'Adresse du Client',
			prop: 'client_address',
		},
		{
			name: 'Prénom du Contact',
			prop: 'contact_firstname',
		},
		{
			name: 'Nom du Contact',
			prop: 'contact_lastname',
		},
		{
			name: 'Fonction',
			prop: 'fonction',
		},
		{
			name: 'Téléphone',
			prop: 'telephone',
		},
		{
			name: 'Email',
			prop: 'email',
		},
	];

	open = _ => {
		if (!this.state.visible) {
			this.setState(_ => ({ visible: true }));
			document.body.addEventListener('click', this.blurWrapper);
		}
	};
	close = _ => {
		this.setState(_ => ({ visible: false }));
		document.body.removeEventListener('click', this.blurWrapper);
	};
	reset = _ => {
		this.setState(_ => ({ name: 'Trier par' }));
	};
	blurWrapper = e => {
		if (!this.wrapper.contains(e.target)) {
			this.close();
		}
	};
	componentWillUnmount() {
		document.body.removeEventListener('click', this.blurWrapper);
	}
	select = f => {
		if (!f) {
			this.setState(
				_ => ({ name: 'Trier par' }),
				_ => {
					FilterEvent.trigger(null);
				}
			);
		} else {
			this.setState(
				_ => ({ name: f.name }),
				_ => {
					FilterEvent.trigger(f.prop);
				}
			);
		}
		this.close();
	};
	render() {
		return (
			<div
				className={css.wrapper}
				onClick={this.open}
				ref={n => (this.wrapper = n)}
				style={{ zIndex: this.state.visible ? 1 : 0 }}
			>
				<div className={css.input + ' ' + css.couilles}>{this.state.name}</div>
				<ul className={css.list + (this.state.visible ? ' visible' : '')}>
					<li
						key="empty"
						onClick={_ => this.select(null)}
						className={css.couilles}
					>
						Trier par
					</li>
					{this.filters.map(f => {
						return (
							<li key={f.prop} onClick={_ => this.select(f)}>
								{f.name}
							</li>
						);
					})}
				</ul>
			</div>
		);
	}
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/filter/filter.js